// components
import { Box, Card, Divider, styled } from '@mui/material';

import { DoubleLabelSwitch } from '../../../../../../components/inputs/switches/DoubleLabelSwitch';

import { OrganizationDetails } from './OrganizationDetails';
import { OrganizationContact } from './OrganizationContact';
import { OrganizationBroker } from './OrganizationBroker';
import { PreviousAgentInfo } from './PreviousAgentInfo';

export const OrganizationDetailsTab = ({
  policy,
  account,
  latestRisk,
}: any) => {
  const { latestRiskSelected, handleLatestRiskToggle } = latestRisk;

  return (
    <OrganizationDetailsTabCard square>
      <Box className="justify-center">
        <DoubleLabelSwitch
          onChange={handleLatestRiskToggle}
          value={latestRiskSelected}
          offLabel="Firmo as of Last Underwriting"
          onLabel="Latest Firmo"
        />
      </Box>
      <OrganizationDetails
        policy={policy}
        account={account}
        latestRiskSelected={latestRiskSelected}
      />
      <Divider style={{ width: '100%', margin: '1rem 0 0.5rem 0' }} />
      <OrganizationContact
        policy={policy}
        account={account}
        latestRiskSelected={latestRiskSelected}
      />
      <Divider style={{ width: '100%', margin: '1rem 0 0.5rem 0' }} />
      <OrganizationBroker policy={policy} />
      <PreviousAgentInfo policy={policy} />
    </OrganizationDetailsTabCard>
  );
};

const OrganizationDetailsTabCard = styled(Card)(({ theme: { palette } }) => ({
  padding: '1rem',
  backgroundColor: palette.background.default,
}));
